import React from "react";

import { useAppType, useGetNewsAndArticles, useTranslation } from "utils";

import { ArticleCard, Carousel, Col, ErrorBoundary, Icon, Link, NewsCard, Row } from "components";

function getArticleColumnClass(isDesktopAppType: boolean, index: number) {
  if (!isDesktopAppType) return "padding-0";

  const colPositionIndex = index % 3;
  if (colPositionIndex === 0) return "article-first-col";
  if (colPositionIndex === 2) return "article-last-col";

  return "";
}

const NewsAndArticles: React.FC = () => {
  const { t } = useTranslation(["articles"]);
  const appType = useAppType();

  const { newNews, newArticles, recommendedArticles } = useGetNewsAndArticles();
  const articlesList = [...(newNews ?? []), ...(recommendedArticles ?? []), ...(newArticles ?? [])].filter((card) => card !== undefined);

  return (
    <ErrorBoundary>
      <section id="article-container">
        <Row>
          <Col>
            <Link to="/search/knowledge" className="articles-title" mixpanelText={t("dashboard.headline")}>
              <h3 className="article-link">
                {t("dashboard.headline")}
                <Icon size="m" iconName="tabler/arrow-narrow-right" className="article-link-icon margin-left-25 inline" />
              </h3>
            </Link>
          </Col>
        </Row>
        {appType.desktop ? (
          <Row className={`${appType.desktop ? "articles-row" : ""} margin-left-0 margin-right-0`}>
            {/* prelint-ignore-col */}
            {articlesList.map((card, i) => (
              <Col key={i} sm={24} md={8} className={getArticleColumnClass(appType.desktop, i)}>
                {card.type === "ARTICLE" ? <ArticleCard link={card?.link} /> : <NewsCard link={card?.link} />}
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            <Col sm={24}>
              {/* @ts-expect-error need to convert to tsx */}
              <Carousel type="mini">
                {articlesList?.map((card) =>
                  card.type === "ARTICLE" ? <ArticleCard link={card.link} key={card.id} /> : <NewsCard link={card.link} key={card.id} />
                )}
              </Carousel>
            </Col>
          </Row>
        )}
      </section>
    </ErrorBoundary>
  );
};

export default NewsAndArticles;
